import { fetchWrapper } from '../Helpers';

const baseUrl = `${process.env.REACT_APP_API_URL}/adv/payment`;

export const billingService = {
  getAll,
  addBalance,
  addSubscribePlan,
  getAllTokenPlan,

};

function getAll(options) {
  let filterString = '';
  if (options.filter) {
    filterString = options.filter;
  }
  if (options.page !== undefined) {
    filterString = getAllPaging(options, filterString);
  }
  const url =
    filterString.length > 0
      ? `${baseUrl}/history?${filterString}`
      : `${baseUrl}/history`;
  return fetchWrapper.get(url);
}


/*function getTokenTxn(options) {

  let filterString = '';
  if (options.filter) {
    filterString = options.filter;
  }
  if (options.page !== undefined) {
    filterString = getAllPaging(options, filterString);
  }
  const url =
    filterString.length > 0
      ? `${baseUrl}/tokenhistory?${filterString}`
      : `${baseUrl}/tokenhistory`;
  return fetchWrapper.get(url);
}*/


function addBalance(params) {
  return fetchWrapper.post(baseUrl, params);
}
function addSubscribePlan(params) {
  return fetchWrapper.post(`${process.env.REACT_APP_API_URL}` + '/paypal/subscribe', params);
}
function getAllTokenPlan() {
  return fetchWrapper.get(`${process.env.REACT_APP_API_URL}` + '/tokenpackage/');
}
function getAllPaging(options, filterString) {
  filterString += filterString.length > 0 ? `&` : '';
  filterString += `page[number]=${options.page}`;
  if (options.pageSize) {
    filterString += filterString.length > 0 ? `&` : '';
    filterString += `page[size]=${options.pageSize}`;
  }
  if (options.fileType) {
    filterString += filterString.length > 0 ? `&` : '';
    filterString += `page[filetype]=${options.fileType}`;
  }
  return filterString;
}
